import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface TrustStat {
  icon: LucideIcon;
  value: string;
  label: string;
}

export const trustStats: TrustStat[] = [
  { icon: UsersIcon, value: '+8K', label: 'Profesores activos' },
  { icon: Building2Icon, value: 'Más de 500', label: 'Colegios e Institutos' },
  { icon: DownloadIcon, value: 'Sesiones', label: 'Listas para usar' },
  { icon: ClockIcon, value: '+12 horas', label: 'Ahorradas / semana' }
];

export interface TrustBadge {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const trustBadges: TrustBadge[] = [
  {
    icon: GraduationCapIcon,
    title: 'Educación Física Real',
    text: 'Diseñado por profesores de EF con años de experiencia en aulas españolas. Para la realidad del patio, los 30 alumnos y el coordinador que pregunta por LOMLOE.'
  },
  {
    icon: LayersIcon,
    title: 'Todas las Etapas',
    text: 'Desde 1º Primaria (6 años) hasta 2º Bachillerato. Con adaptaciones específicas para cada maduración motriz y nivel de autonomía.'
  },
  {
    icon: SmartphoneIcon,
    title: 'Multidispositivo',
    text: 'Tablet, móvil, PC o para imprimir — consulta desde el patio sin que nadie lo note.'
  }
];
